<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-scale-party" [fullScreen]="true"><p style="color: white" > Loading... </p></ngx-spinner>
<router-outlet></router-outlet>